import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Video, CheckCircle, Clock, FileText, XCircle } from 'lucide-react';

interface StatsOverviewProps {
  totalVideos: number;
  imported: number;
  scheduled: number;
  published: number;
  blocked: number;
}

export default function StatsOverview({ totalVideos, imported, scheduled, published, blocked }: StatsOverviewProps) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-5 gap-6 mb-8">
      <Card className="border border-slate-200">
        <CardContent className="pt-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-slate-600">Total Videos</p>
              <p className="text-2xl font-bold text-slate-900">{totalVideos}</p>
            </div>
            <div className="h-12 w-12 bg-blue-100 rounded-lg flex items-center justify-center">
              <Video className="text-blue-600" size={24} />
            </div>
          </div>
        </CardContent>
      </Card>
      
      <Card className="border border-slate-200">
        <CardContent className="pt-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-slate-600">Draft</p>
              <p className="text-2xl font-bold text-slate-900">{imported}</p>
            </div>
            <div className="h-12 w-12 bg-slate-100 rounded-lg flex items-center justify-center">
              <FileText className="text-slate-600" size={24} />
            </div>
          </div>
        </CardContent>
      </Card>
      
      <Card className="border border-slate-200">
        <CardContent className="pt-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-slate-600">Scheduled</p>
              <p className="text-2xl font-bold text-slate-900">{scheduled}</p>
            </div>
            <div className="h-12 w-12 bg-amber-100 rounded-lg flex items-center justify-center">
              <Clock className="text-amber-600" size={24} />
            </div>
          </div>
        </CardContent>
      </Card>
      
      <Card className="border border-slate-200">
        <CardContent className="pt-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-slate-600">Published</p>
              <p className="text-2xl font-bold text-slate-900">{published}</p>
            </div>
            <div className="h-12 w-12 bg-green-100 rounded-lg flex items-center justify-center">
              <CheckCircle className="text-green-600" size={24} />
            </div>
          </div>
        </CardContent>
      </Card>
      
      <Card className="border border-slate-200">
        <CardContent className="pt-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-slate-600">Blocked</p>
              <p className="text-2xl font-bold text-slate-900">{blocked}</p>
            </div>
            <div className="h-12 w-12 bg-red-100 rounded-lg flex items-center justify-center">
              <XCircle className="text-red-600" size={24} />
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
